import { gql } from "@grandvisionhq/graphql";
const GET_LATEST_DELIVERY_FOR_ESTIMATION_ITEMS = gql`
  query LatestDeliveryForEstimationItems($input: EstimatedDeliveryByEstimationItemsInput!) {
    latestDeliveryForEstimationItems(input: $input) {
      __typename
      ... on LatestDeliveryEstimationSuccessResponse {
        __typename
        result {
          shippingMethodKey
          earliestDeliveryDate
          latestDeliveryDate
        }
      }
      ... on DeliveryEstimationsFailureResponse {
        failures {
          ... on GenericEstimationFailure {
            message
          }
        }
      }
    }
  }
`;
export {
  GET_LATEST_DELIVERY_FOR_ESTIMATION_ITEMS
};
//# sourceMappingURL=latestDeliveryForEstimationItems.js.map
